export const ImgPlaceholder = ({ ...restProps }) => {
  return (
    <svg viewBox="0 0 100 100" fill="#146CFF" fillRule="evenodd" clipRule="evenodd" fillOpacity="0.2" {...restProps}>
      <path d="M80.8652 48.034L73.7249 41.0127L73.6965 41.2193L72.7676 48.0159L80.8652 48.034Z" />
      <path d="M63.7617 43.2768L71.9395 50.6899L71.9346 50.6933L71.9432 50.7012L72.3096 48.0153L73.2386 41.2187L73.2682 40.9951L63.7617 43.2768Z" />
      <path d="M45.2625 51.2725L45.1811 51.5107L41.5332 77.6166L52.6101 67.6227L52.3103 66.9555L52.108 66.5072L45.3439 51.4531L45.2625 51.2725Z" />
      <path d="M44.8929 51.3843L32.3604 38.9912L19 38.6514L44.851 51.5051L44.8929 51.3843Z" />
      <path d="M44.9591 50.9834L44.9986 50.8671L45.8449 28.0127L21.9492 28.2283L32.4278 38.5903L44.9591 50.9834Z" />
      <path d="M63.4693 43.6209L46.234 28L46.1477 28.0011L45.3125 50.5959L52.2419 66.0169L71.5484 51.1084L71.6421 51.0373L71.6471 51.0328L63.4693 43.6209Z" />
      <path d="M71.7998 51.4137L52.4082 66.3866L52.6105 66.8371L71.352 55.2569L71.8911 51.3438L71.7998 51.4137Z" />
    </svg>
  )
}
